import React from 'react';
import { motion } from 'framer-motion';
import Container from '../common/container';

export default function AboutHero() {
  return (
    <section className="py-20 md:py-28 bg-gradient-to-b from-white to-gray-50">
      <Container>
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl mx-auto text-center"
        >
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
            About <span className="text-primary">WymBee</span>
          </h1>
          <p className="text-xl text-gray-600 leading-relaxed">
            Transforming messaging apps into powerful business engines for the next billion users.
          </p>
          
          <div className="mt-12 flex justify-center">
            <div className="w-24 h-1 bg-gradient-to-r from-primary/20 via-primary to-primary/20 rounded-full"></div>
          </div>
        </motion.div>
      </Container>
    </section>
  );
}